import type { CleaningTaskQueueResponse } from '@/shared/api';
import { filterCleaningDay, type CleaningDayFilter } from './cleaningDayModel';
import { CleaningTaskRow } from './CleaningTaskRow';

interface Props {
  tasks: CleaningTaskQueueResponse[];
  date: string;
  filter: CleaningDayFilter;
  /** Die Liste ist nach einer Person gefiltert — der leere Satz sagt das. */
  personFiltered: boolean;
  /** Ohne Netz kein Übernehmen. */
  offline: boolean;
  selectedId: string | null;
  onSelect: (task: CleaningTaskQueueResponse, trigger: HTMLElement) => void;
  onClaim: (task: CleaningTaskQueueResponse) => void;
  claimingId?: string;
  currentUserId?: string;
}

const EMPTY: Record<CleaningDayFilter, string> = {
  all: 'An diesem Tag keine Reinigungen.',
  free: 'An diesem Tag ist keine Aufgabe frei.',
  active: 'An diesem Tag wird gerade nichts gereinigt.',
  overdue: 'An diesem Tag ist nichts überfällig.',
  completed: 'An diesem Tag ist noch nichts erledigt.',
};

/** Die Tagesliste der Leitung; Status und Zahlen stehen als Reiter im Kopf. */
export function CleaningDayBoard(props: Props) {
  const visible = filterCleaningDay(props.tasks, props.filter);
  if (visible.length === 0)
    return (
      <p className="border-hairline rounded-tile text-ink-soft border bg-white p-5 text-sm">
        {props.personFiltered
          ? 'Für die gewählte Person gibt es hier an diesem Tag nichts.'
          : EMPTY[props.filter]}
      </p>
    );
  return (
    <ul className="border-hairline rounded-tile overflow-hidden border bg-white">
      {visible.map((task) => (
        <CleaningTaskRow
          key={task.id}
          task={task}
          date={props.date}
          selected={task.id === props.selectedId}
          onSelect={props.onSelect}
          onClaim={props.onClaim}
          claiming={task.id === props.claimingId}
          offline={props.offline}
          currentUserId={props.currentUserId}
        />
      ))}
    </ul>
  );
}
